import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['toggle', 'menu'];

    connect() {
        this.boundClose = this.closeOnOutsideClick.bind(this);
        document.addEventListener('click', this.boundClose);
    }

    disconnect() {
        document.removeEventListener('click', this.boundClose);
    }

    toggle(event) {
        event.preventDefault();
        event.stopPropagation();

        const isOpen = !this.menuTarget.hidden;
        this.setOpen(!isOpen);
    }

    closeOnOutsideClick(event) {
        if (!this.element.contains(event.target)) {
            this.setOpen(false);
        }
    }

    setOpen(open) {
        this.menuTarget.hidden = !open;
        this.toggleTarget.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.element.classList.toggle('is-open', open);
    }
}
